<head>
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
</head>

<body>
  <app-loading></app-loading>
  <div fxFlex fxFill class="container app-container">
    <router-outlet></router-outlet>
  </div>
</body>
